import type { FC } from "react";
import { Alert, Button } from "@mui/material";

export const QueryErrorAlert: FC<{ onRetry: () => void; message?: string }> = ({
  onRetry,
  message = "Не удалось загрузить данные",
}) => (
  <Alert
    severity="error"
    action={
      <Button color="inherit" size="small" onClick={onRetry}>
        Повторить
      </Button>
    }
  >
    {message}
  </Alert>
);
